// @flow
/** @jsx isolateComponent */

import { get } from 'lodash';
import {
  type Component,
  Fragment,
  type Node,
  useEffect,
  useState,
} from 'react';

import {
  type Plan,
  isolateComponent,
  sendFullStoryEvent,
} from '@zapier/common-utils';

import UpgradeModal from './Modal';

import type { TrialExtensionReason } from '@zapier/billing';

type InlineUpgradeTriggerChildProps = {|
  triggerModal: () => void,
  reasonKey: TrialExtensionReason,
  planName: string,
|};

type Props = {|
  appName?: string,
  autoOpen?: boolean,
  canExtendTrial: boolean,
  ChangePlanContainer: Component<*>,
  children?: InlineUpgradeTriggerChildProps => Node,
  didExtendTrial: boolean,
  upgradeToPlan: Plan,
  validationReason: TrialExtensionReason,
  onClose: () => void,
  onExtendTrial: TrialExtensionReason => void,
  onUpgradeFinish: () => void,
|};

const Trigger = ({ children, ...props }: Props) => {
  const [isOpen, setIsOpen] = useState(props.autoOpen || false);
  const open = () => setIsOpen(true);
  const close = () => {
    props.onClose();
    setIsOpen(false);
  };

  // Fire off FS events
  useEffect(() => {
    if (children && props.validationReason) {
      sendFullStoryEvent('Viewed Inline Upgrade CTA');
    }
  }, [children, props.validationReason]);
  useEffect(() => {
    if (isOpen) {
      sendFullStoryEvent('Opened Inline Upgrade Modal');
    }
  }, [isOpen]);

  return (
    <Fragment>
      {children
        ? children({
            triggerModal: open,
            reasonKey: props.validationReason,
            planName:
              get(props.upgradeToPlan, 'type') ||
              get(props.upgradeToPlan, 'name'),
          })
        : null}
      {isOpen && <UpgradeModal {...props} onClose={close} />}
    </Fragment>
  );
};

export default Trigger;
